// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import { productService } from "../../../services/productService";

// Simplified default filter options
export const defaultFilterOptions = {
  location: [
    { value: "HAD", label: "HAD" },
    { value: "Berlin", label: "Berlin" },
    { value: "München", label: "München" },
  ],
  status: [
    { value: "active", label: "Aktiv" },
    { value: "inactive", label: "Inaktiv" },
    { value: "archived", label: "Archiviert" },
    { value: "fordeletion", label: "Zur Löschung" },
  ],
  type: [],
  product_type: [],
  scenarios: [],
  layout_positions: [],
  paket_options: [],
  applicable_for_options: [
    { value: "internal", label: "Intern" },
    { value: "external", label: "Extern" },
    { value: "both", label: "Beide" },
  ],
};

// Function to fetch filter options from API
export const fetchFilterOptions = async () => {
  try {
    const filtersData = await productService.getAllFilters();

    const filterOptions = {
      location: filtersData.locations.map((item) => ({
        value: item.id,
        label: item.name,
        vhp_code: item.vhp_code,
      })),
      status: filtersData.status.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      type: filtersData.categories.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      product_type: filtersData.productTypes.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      scenarios: filtersData.scenarios.map((item) => ({
        // The product's bookable_for is a backend enum of scenario CODES
        // (e.g. "delivery"), so the filter value must be the code — not the
        // display name ("Ladebereich"), which the API rejects as invalid.
        value: item.scenario_code || item.name,
        label: item.name || item.description || "Unknown",
        name: item.name,
        event_type: item.event_type,
        event_size: item.event_size,
      })),
      layout_positions: filtersData.layoutPositions.map((item) => ({
        value: item,
        label: item,
      })),
      paket_options: filtersData.paketOptions.map((item) => ({
        value: item,
        label: item,
      })),
      applicable_for_options: filtersData.applicableForOptions.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    };

    return filterOptions;
  } catch (error) {
    console.error("Error fetching filter options:", error);
    return defaultFilterOptions;
  }
};

// Filter configuration for different tabs
export const getFilterConfig = (
  currentTab,
  filterOptions = defaultFilterOptions,
) => {
  const options = filterOptions || defaultFilterOptions;
  const baseConfig = {
    location: {
      label: "Standort",
      options: options.location,
    },
    status: {
      label: "Status",
      options: options.status,
    },
    type: {
      label: "Kategorie",
      options: options.type,
    },
    product_type: {
      label: "Typ",
      options: options.product_type,
    },
    scenarios: {
      label: "Buchbar für",
      options: options.scenarios,
    },
    layout_positions: {
      label: "Layout Position",
      options: options.layout_positions,
    },
    paket_options: {
      label: "Paket",
      options: options.paket_options,
    },
    applicable_for: {
      label: "Anwendbar für",
      options: options.applicable_for_options,
    },
  };

  switch (currentTab) {
    case "bookable":
      return {
        ...baseConfig,
      };
    case "all":
      return baseConfig;
    case "preise":
      return {
        ...baseConfig,
      };
    default:
      return baseConfig;
  }
};
